module.exports = __webpack_public_path__ + "img/c2.336a8f7e.png";